import { combineReducers } from 'redux';

export function createReducerManager(initialReducers) {
    const reducers = { ...initialReducers };
    let combinedReducer = combineReducers(reducers);

    return {
        getReducerMap: () => reducers,
        reduce: (state, action) => combinedReducer(state, action),
        add: (key, reducer) => {
            if (reducers[key]) {
                return;
            }
            reducers[key] = reducer;
            combinedReducer = combineReducers(reducers);
        },
    };
}

export function injectReducer(store, key, reducer) {
    store.reducerManager.add(key, reducer);
    store.replaceReducer(store.reducerManager.reduce);
}
